import { emailListValidation } from '../../validation/email-list-validation';


/* eslint-disable */
export const sendBillingData: any = [
  {
    "field_map": "emails",
    "item_name": "emails",
    "title": "Email address",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": emailListValidation(true),
  },
  {
    "field_map": "ccs",
    "item_name": "ccs",
    "title": "CC",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": emailListValidation(true),
  },
  {
    "field_map": "bccs",
    "item_name": "bccs",
    "title": "BCC",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": emailListValidation(true),
  },
  {
    "field_map": "subject",
    "item_name": "subject",
    "title": "Subject",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'SHARE_BILLING_VALIDATION': {
        required: true,
        message: 'Subject must be provided',
      },
    },
  },
  {
    "field_map": "body",
    "item_name": "body",
    "title": "Body",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
    "validation": {
      'SHARE_BILLING_VALIDATION': {
        required: true,
        message: 'Body must be provided',
      },
    },
  },
];
/* eslint-enable */
